module.exports = __webpack_public_path__ + "img/ticket_star.1a4c3436.svg";